import React from 'react'
import { AvatarType, AvatarImage, AvatarInitials } from '../../types.d'

export default function Avatar(props: AvatarType) {
  switch (props.type) {
    case 'image':
      return (
        <img
          className="mx-auto size-16 rounded-xl sm:ml-0 sm:mr-6"
          src={props.url}
          alt="User Avatar"
        />
      )
    case 'initials':
      return (
        <div
          className="mx-auto size-16 rounded-xl sm:ml-0 sm:mr-6 flex items-center justify-center"
          style={{ backgroundColor: props.color }}
        >
          <span className="text-white font-bold text-2xl">
            {props.initials}
          </span>
        </div>
      )
    /* istanbul ignore next */
    default:
      const _exhaustive: never = props
      return null
  }
}
